import axiosInstance from "../axiosInstance";

export const disbursementApi = {
  post: (path, params, headers, cancelToken) =>
    axiosInstance
      .post(`/Disbursements${path}`, params, {
        cancelToken: cancelToken?.token,
        headers,
      })
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
        // if (res?.data?.error || res?.data?.status === 'error') throw res.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
  get: (path, params, headers, cancelToken) =>
    axiosInstance
      .get(
        `/Disbursements${path}`,
        { params },
        {
          cancelToken: cancelToken?.token,
          headers,
        }
      )
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
};

// export const getAdditionalInstitutes = async (params) =>
//   applicationsApi.post("/GetAdditionalInstitutes", JSON.stringify(params), {
//     "Content-Type": "application/json",
//   });

export const getEligibleApplications = async () =>
  disbursementApi.get("/GetEligibleApplications");

export const getDisbursementApplications = async () =>
  disbursementApi.get("/GetDisbursements");

export const createDisbursement = async (params) =>
  disbursementApi.post("/Create", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const getDisbursement = async (id) =>
  disbursementApi.get(`/GetDisbursement/${id}`);

// export const getApplication = async (id) =>
//   applicationsApi.get(`/GetApplication/${id}`);

// export const getAmkaRegistryInfo = async (params) =>
//   applicationsApi.get("/GetAmkaRegistryInfo", params);

export const updateDisbursement = async (params) => {
  return disbursementApi.post("/Update", JSON.stringify(params), {
    "Content-Type": "application/json",
  });
};

export const reviseHistoryLog = async (params) => {
  return disbursementApi.post("/ReviseHistoryLog", JSON.stringify(params), {
    "Content-Type": "application/json",
  });
};

export const getAmendmentStatus = async (id) =>
  disbursementApi.get(`/GetAmendmentStatus/${id}`);

export const amendApplication = async (params) => {
  return disbursementApi.post("/AmendApplication", JSON.stringify(params), {
    "Content-Type": "application/json",
  });
};
